const HomepageSlideTimezone = () => {
    return (
        <>
            {/* Todo: declare `width` and `height` attributes here. */}
            <img
                src="./images/homepage_rebrand/slider/clock.png"
                alt="Privacy widget"
                width="160"
                height="160"
                className="timezone timezone--first"
            />
            <img
                src="./images/homepage_rebrand/slider/timezone.png"
                alt="Privacy widget"
                width="329"
                height="244"
                className="timezone-widget"
            />
        </>
    );
};

export default HomepageSlideTimezone;
